const offensiveFoulSecondDefenderActions = [
  {
    actions: [
      { action: "sendEvent", value: "new", type: "main" },
      { action: "nextState", value: null, type: "primary" },
      { action: "processInserts", value: "all", type: "inserts" },
    ],
    conditions: [],
  },
];

export const OffensiveFoulSecondDefender = {
  name: "offensive-foul-second-defender",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "offensiveFoul.secondDefender.select",
  showOn: [{ state: "primary", value: "offensive-foul-second-defender", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  allowBack: {
    state: "primary",
    value: "offensive-foul-first-defender",
    event: "offensive-foul-first-defender",
  },
  children: [
    {
      name: "prepare-offensive-foul-second-defender",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "copyEvent", value: "offensive-foul-first-defender", type: "from" },
            { action: "newEvent", value: null, type: "main" },
            {
              action: "clearData",
              value: ["personId", "flagged", "scores", "success"],
              type: "main",
            },
            { action: "saveData", value: "foul", type: "eventType" },
            { action: "saveData", value: "drawn", type: "subType" },
            {
              action: "saveData",
              value: [{ option: "offensive", value: true }],
              type: "options",
            },
            { action: "copyEvent", value: "offensive-foul-second-defender", type: "to" },
          ],
          conditions: [
            {
              item: "eventDefined",
              value: "offensive-foul-second-defender",
              operator: "not",
            },
          ],
        },
        {
          actions: [{ action: "copyEvent", value: "offensive-foul-second-defender", type: "from" }],
          conditions: [
            {
              item: "eventDefined",
              value: "offensive-foul-second-defender",
              operator: "is",
            },
          ],
        },
      ],
    },
    {
      name: "offensive-foul-second-defender-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
        excludePlayer: true,
        excludeFrom: "offensive-foul-first-defender",
      },
      actionGroups: offensiveFoulSecondDefenderActions,
    },
    {
      name: "no-second-defender",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: "noSecondDefender",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "clearEvent", value: "offensive-foul-second-defender" },
            { action: "nextState", value: null, type: "primary" },
            { action: "processInserts", value: "all", type: "inserts" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
